import type { MoreLinkArg } from '@fullcalendar/core';
import { getLocale } from '../../../../../utils/i18n';

type MoreEventsDayDialogEvent = {
  id: string;
  title: string;
  extendedProps: Record<string, unknown>;
};

export type MoreEventsDayDialogState = {
  dateIso: string;
  events: MoreEventsDayDialogEvent[];
};

/** Parse YYYY-MM-DD as a local calendar date (not UTC midnight). */
function parseCalendarDateString(dateIso: string): Date {
  const [year, month, day] = dateIso.split('-').map(Number) as [number, number, number];
  return new Date(year, month - 1, day);
}

function toCalendarDateIsoString(date: Date): string {
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/** Read the clicked day cell's `data-date`; never parse that string as UTC. */
export function getMoreLinkDayDateIso(info: MoreLinkArg): string {
  const linkEl = info.jsEvent.currentTarget as HTMLElement;
  const dateIso =
    linkEl.closest('.fc-daygrid-day')?.getAttribute('data-date') ??
    linkEl.closest('[data-date]')?.getAttribute('data-date');

  if (dateIso) {
    return dateIso;
  }

  return toCalendarDateIsoString(info.date);
}

export function formatMoreEventsDayLabel(dateIso: string): string {
  return parseCalendarDateString(dateIso).toLocaleDateString(getLocale(), {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });
}
